<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.partecipa.id != null ? 'Partecipazione #' + this.partecipa.id : 'Nuova partecipazione') + ' - ' + getDescTipo(this.partecipa.tipo) + ' #' + this.partecipa.id_scheda">

                    <b-container fluid class="mx-auto text-left" v-if="showdettaglio3 && showdettaglio2  && (showdettaglio || partecipa.id == null)">
                         <b-row class="my-1">
                                    <b-col sm="3"><label for="coso">Cognome socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="partecipa.cognomesocio" id="coso" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="noso">Nome socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="partecipa.nomesocio" id="noso" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="maso">Email socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="partecipa.accountsocio" id="maso" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note socio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="note" v-model="partecipa.noteutente" :rows="3" :disabled="(modifica && partecipa.id != null) /*|| tipoevento == 'R'*/"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="note" v-model="partecipa.note" :rows="3" :disabled="(modifica && partecipa.id != null) /*|| tipoevento == 'R'*/"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="numposti">Numero posti:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="partecipa.numposti" id="numposti" type="number" :disabled="(modifica && partecipa.id != null) || tipoevento == 'R'"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row v-show="getShowImportiPagamento()" class="my-1">
                                    <b-col sm="3"><label for="importoacconto">Importo acconto:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="partecipa.importoacconto" id="importoacconto" type="number" :disabled="(modifica && partecipa.id != null) || tipoevento == 'R'"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row v-show="getShowImportiPagamento()" class="my-1">
                                    <b-col sm="3"><label for="importosaldo">Importo saldo:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="partecipa.importosaldo" id="importosaldo" type="number" :disabled="(modifica && partecipa.id != null) || tipoevento == 'R'"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row v-show="getShowImportiPagamento()" class="my-1">
                                    <b-col sm="3"><label for="importoscontoacconto">Importo sconto acconto:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="partecipa.importoscontoacconto" id="importoscontoacconto" type="number" :disabled="(modifica && partecipa.id != null) /*|| tipoevento == 'R'*/"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row v-show="getShowImportiPagamento()" class="my-1">
                                    <b-col sm="3"><label for="importoscontosaldo">Importo sconto saldo:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="partecipa.importoscontosaldo" id="importoscontosaldo" type="number" :disabled="(modifica && partecipa.id != null) /*|| tipoevento == 'R'*/"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row v-show="(getShowImportiPagamento() || partecipa.totalepagato > 0) && partecipa.totacconto != ''" class="my-1">
                                    <b-col sm="3"><label for="totacconto">Acconto riscosso/totale:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input disabled :style="getImportoStyle(partecipa.totacconto)" v-model="partecipa.totacconto" id="totacconto" type="text"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row v-show="(getShowImportiPagamento() || partecipa.totalepagato > 0) && partecipa.totsaldo != ''" class="my-1">
                                    <b-col sm="3"><label for="importosaldo">Saldo riscosso/totale:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input disabled :style="getImportoStyle(partecipa.totsaldo)" v-model="partecipa.totsaldo" id="totsaldo" type="text"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flagsta">Stato:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="partecipa.flagsta" :options="options_stati" id="flagsta" :disabled="(modifica && partecipa.id != null) /*|| tipoevento == 'R'*/">

                                        </b-form-select>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-if="partecipa.id != null">
                                    <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="partecipa.datains" id="datains" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-if="partecipa.id != null">
                                    <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="partecipa.uteins" id="uteins" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-3" v-show="parametri.flgpagamenti == 'S' && partecipa.id != null && partecipa.tipo == 'E' && partecipa.id_socio != null">
                                    <b-col sm="9" offset-sm="3">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="pagamenti()">
                                            Pagamenti
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <b-row class="my-3">
                                    <b-col sm="5" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="modifica && partecipa.id != null">
                                                Modifica
                                            </div>
                                            <div v-else>
                                                <div v-if="partecipa.id != null">
                                                    Salva
                                                </div>
                                                <div v-else>
                                                    Inserisci
                                                </div>
                                            </div>
                                        </b-button>
                                    </b-col>
                                    <b-col sm="4">
                                        <b-button v-if="partecipa.id == null" block size="md" variant="outline-secondary" v-on:click="selSocio()">
                                            Seleziona socio
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

            <!-- Modal Component -->
            <b-modal size="lg" v-model="sociModal.show" title="Seleziona il socio">
                <!-- <p class="my-2">Seleziona il socio</p> -->

                <div class="text-left">
                    <div class="my-1 row">
                        <div class="col-md-3">
                            <b-form-input v-model="sociModal.filter" placeholder="Cerca..." />
                        </div>
                    </div>

                    <!-- Main table element -->
                    <b-table responsive small id="main-table" striped hover show-empty :items="sociModal.items" :fields="sociModal.fields" :current-page="sociModal.currentPage" :per-page="sociModal.perPage" :filter="sociModal.filter" :sort-by.sync="sociModal.sortBy" :sort-desc.sync="sociModal.sortDesc"
                        @filtered="onFiltered">
                        <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="cognome" scope="row">{{row.value}}</template>
                        <template slot="nome" scope="row">{{row.value}}</template>
                        <!-- <template slot="matricola" scope="row">{{row.value}}</template> -->
                        <template slot="email" scope="row">{{row.value}}</template>
                        <template slot="seleziona" scope="row">
                        <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                        <b-btn size="sm" variant="danger" @click.stop="seleziona(row.item,row.index,$event.target)">Seleziona</b-btn>
                    </template>
                    </b-table>


                    <div class="row my-1">
                        <div class="col-md-7 col-sm-12">
                            <b-pagination :total-rows="totalRows" :per-page="sociModal.perPage" v-model="sociModal.currentPage" />
                        </div>
                        <div class="col-md-5 col-sm-12 text-right">
                            <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                                <b-form-select :options="sociModal.pageOptions" v-model="sociModal.perPage" />
                            </b-form-fieldset>
                        </div>
                    </div>
                </div>


                <div slot="modal-footer" class="w-100">
                    <b-btn size="sm" class="float-right" variant="secondary" @click="sociModal.show=false" style="margin: 2px;">
                        Chiudi
                    </b-btn>
                </div>
            </b-modal>

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

import {
    Partecipa,
    Categoria,
    Socio,
    Visibilità
} from '../classes.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {
            namespace: NAMESPACE,
            partecipa: {
                id: this.$route.params.id,
                id_scheda: this.$route.params.id_scheda,
                tipo: this.$route.params.tipo,
                id_socio: null,
                datains: null,
                uteins: '',
                nomesocio: '',
                cognomesocio: '',
                accountsocio: '',
                noteutente: '',
                note: '',
                numposti: 1,
                flagsta: 'I',
                importoacconto: 0,
                importosaldo: 0,
                importoscontoacconto: 0,
                importoscontosaldo: 0,
                tipopagamentoevento: 'N',
                totalesaldo: 0,
                totaleacconto: 0,
                totalepagato: 0,
                totsaldo: '',
                totacconto: '',
            },
            options_stati: [],
            parametri: null,
            tipoevento: this.$route.params.tipoevento,
            error: '',
            showerror: false,
            showdettaglio: false,
            showdettaglio2: false,
            showdettaglio3: false,
            dismissSecs: 2,
            dismissCountDown: 0,
            modifica: true,
            sociModal: {
                show: false,
                items: [],
                fields: {
                    id: {
                        label: '#',
                        sortable: true
                    },
                    cognome: {
                        label: 'Cognome',
                        sortable: true
                    },
                    nome: {
                        label: 'Nome',
                        sortable: true
                    },
                    /*
                                        account: {
                                            label: 'Matricola',
                                            sortable: true
                                        }, */
                    email: {
                        label: 'Email',
                        sortable: true
                    },
                    seleziona: {
                        label: ' ',
                        'class': 'text-right'
                    }
                },
                currentPage: 1,
                perPage: 5,
                pageOptions: [{
                    text: 5,
                    value: 5
                }, {
                    text: 10,
                    value: 10
                }, {
                    text: 15,
                    value: 15
                }],
                sortBy: null,
                sortDesc: false,
                filter: null,
                totalRowsFilter: null,
            },
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.sociModal.totalRowsFilter || this.sociModal.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.sociModal.totalRowsFilter = newValue;
            }
        }

    },
    methods: {
        getScontoEventoSocio(){

            var token = localStorage.getItem('token');
            //this.axios.get(NAMESPACE + 'rest/soci', {
                this.axios.get(NAMESPACE + 'rest/sconti/id_scheda/' + this.partecipa.id_scheda + '/tipo/' + this.partecipa.tipo + '/id_socio/' + this.partecipa.id_socio, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);
                            var res = response.data.message;
                            var importoscontoaccontoAux = 0;
                            var importoscontosaldoAux = 0;
                            if (res.length > 0) {

                                //forse può essere fatta diversamente e meglio
                                for (var i = 0; i < res.length; i++) {
                                    if(importoscontoaccontoAux + importoscontosaldoAux < Math.max(res[i].importoacconto,0) + Math.max(res[i].importosaldo,0)){
                                        importoscontoaccontoAux = Math.max(res[i].importoacconto,0);
                                        importoscontosaldoAux = Math.max(res[i].importosaldo,0);
                                    }
                                }

                            }

                            this.partecipa.importoscontoacconto = importoscontoaccontoAux;
                            this.partecipa.importoscontosaldo = importoscontosaldoAux;

                            this.sociModal.show = false;

                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        this.sociModal.showerror = true;
                        this.sociModal.error = "Errore: " + e.message;
                        alert("Errore caricamento sconti: " + e.message); //si visualizza anche con alert per dargli più rilevanza
                    }

                })
                .catch(e => {
                    this.sociModal.showerror = true;
                    this.sociModal.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    alert("Errore caricamento sconti: " + e.message); //si visualizza anche con alert per dargli più rilevanza
                });



        },
        seleziona(item, index, button) {
            this.partecipa.id_socio = item.id;
            this.partecipa.nomesocio = item.nome;
            this.partecipa.cognomesocio = item.cognome;
            this.partecipa.accountsocio = item.email;
            //this.sociModal.show = false;

            this.getScontoEventoSocio();
        },
        pagamenti() {

            this.$router.push({
                path: `/app/pagamenti/id_evento/${this.partecipa.id_scheda}/id_socio/${this.partecipa.id_socio}/id_partecipa/${this.partecipa.id}`
            });

        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        getDescTipo(tipo) {
            var cat = new Categoria();
            return cat.getTipoByFlag(tipo);
        },
        getShowImportiPagamento() {

            return (this.parametri.flgpagamenti == 'S' && this.partecipa.tipopagamentoevento != 'N' /*this.partecipa.tipopagamentoevento == 'M' && this.partecipa.flagsta == 'C'*/);

        },
        getImportoStyle(importo){
            if(typeof importo != 'undefined' && importo.indexOf("/") >= 0){
                var parz = Number.parseFloat(importo.split('/')[0]);
                var tot = Number.parseFloat(importo.split('/')[1]);
                if(parz == tot){
                    return "font-weight:bold;color:green;";
                }
                if(parz < tot){
                    return "font-weight:bold;color:red;";
                }
                else{
                    return "font-weight:bold;color:blue;";
                }
            }
            return "";
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.sociModal.totalRows = filteredItems.length;
            this.sociModal.currentPage = 1;
        },
        selSocio() {

                var token = localStorage.getItem('token');
                this.axios.get(NAMESPACE + 'rest/soci/id_scheda/' + this.partecipa.id_scheda + '/tipo/' + this.partecipa.tipo, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                this.sociModal.items = response.data.message;
                                this.sociModal.items.forEach(function(element, index) {
                                    delete element.uteins; //per motivi di ricerca
                                });
                                this.sociModal.show = true;

                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            this.sociModal.showerror = true;
                            this.sociModal.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.sociModal.showerror = true;
                        this.sociModal.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

        },
        insert() {

                var appdettaglio = this;

                if (this.modifica && this.partecipa.id != null) {

                    this.modifica = false;
                } else {

                    if (this.partecipa.id_socio == null) {
                        alert("Nessun socio selezionato!");
                        return;
                    }

                    if (this.partecipa.numposti <= 0) {
                        alert("Il numero dei posti deve essere > 0!");
                        return;
                    }

                    if (this.partecipa.importoacconto < 0 && this.getShowImportiPagamento()) {
                        alert("Importo acconto < 0!");
                        return;
                    }

                    if (this.partecipa.importosaldo < 0 && this.getShowImportiPagamento()) {
                        alert("Importo saldo < 0!");
                        return;
                    }

                    var partecipaAux = this.partecipa;

                    delete partecipaAux.datains;

                    var json = JSON.stringify(partecipaAux);

                    //console.log(json);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/partecipa', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.showpassword = false;
                                        this.partecipa = res[0];

                                        this.partecipa.totacconto = Number.parseFloat((this.partecipa.totalesaldo == 0 ? this.partecipa.totalepagato : Math.min(this.partecipa.totaleacconto, this.partecipa.totalepagato))).toFixed(2) + "/" + Number.parseFloat(this.partecipa.totaleacconto).toFixed(2);
                                        this.partecipa.totacconto = (this.partecipa.totacconto == '0.00/0.00' ? '' : this.partecipa.totacconto);

                                        var auxdiff = this.partecipa.totalepagato - (this.partecipa.totalesaldo == 0 ? this.partecipa.totalepagato : Math.min(this.partecipa.totaleacconto, this.partecipa.totalepagato));
                                        auxdiff = (auxdiff < 0 ? 0 : auxdiff);
                                        this.partecipa.totsaldo = Number.parseFloat(auxdiff).toFixed(2) + "/" + Number.parseFloat(this.partecipa.totalesaldo).toFixed(2);
                                        this.partecipa.totsaldo = (this.partecipa.totsaldo == '0.00/0.00' ? '' : this.partecipa.totsaldo);

                                        //alert("totalesaldo " + this.partecipa.totalesaldo + " - totalepagato " + this.partecipa.totalepagato);
                                        //alert("totacconto " + this.partecipa.totacconto + " - totsaldo " + this.partecipa.totsaldo);

                                        this.showerror = false;
                                        this.showdettaglio = this.showdettaglio3 = true; //anche se non dovrebbe servire
                                        this.dismissCountDown = this.dismissSecs;
                                        this.modifica = true;

                                        //qui non importa
                                        //this.$router.replace('/app/dettagliopartecipa/' + this.partecipa.id);

                                        setTimeout(function() {
                                            //window.history.back();
                                            appdettaglio.$router.go(-1);
                                        }, 2500);

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                appdettaglio.showerror = true;
                                appdettaglio.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });
                }

            }

    },
    created: function () {

            if(!ctrlVismenu("E")){
                this.$router.replace('/accessdenied');
                return;
            }

            var partecipa = new Partecipa();
            var options = [];
            var listaStati = Object.keys(partecipa.getListaStati());
            for (var i = 0; i < listaStati.length; i++) {
                options.push({
                    value: listaStati[i],
                    text: partecipa.getStatoByFlag(listaStati[i])
                });
            }
            this.options_stati = options;

            var id = this.partecipa.id; //se è la prima volta si prova a prendere da getid

            var appdettaglio = this;

            if (id != null) {

                var token = localStorage.getItem('token');

                this.axios.get(NAMESPACE + 'rest/partecipa/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.partecipa = res[0];

                                    //console.log(JSON.stringify(this.partecipa))

                                    this.partecipa.totacconto = Number.parseFloat((this.partecipa.totalesaldo == 0 ? this.partecipa.totalepagato : Math.min(this.partecipa.totaleacconto, this.partecipa.totalepagato))).toFixed(2) + "/" + Number.parseFloat(this.partecipa.totaleacconto).toFixed(2);
                                    this.partecipa.totacconto = (this.partecipa.totacconto == '0.00/0.00' ? '' : this.partecipa.totacconto);

                                    var auxdiff = this.partecipa.totalepagato - (this.partecipa.totalesaldo == 0 ? this.partecipa.totalepagato : Math.min(this.partecipa.totaleacconto, this.partecipa.totalepagato));
                                    auxdiff = (auxdiff < 0 ? 0 : auxdiff);
                                    this.partecipa.totsaldo = Number.parseFloat(auxdiff).toFixed(2) + "/" + Number.parseFloat(this.partecipa.totalesaldo).toFixed(2);
                                    this.partecipa.totsaldo = (this.partecipa.totsaldo == '0.00/0.00' ? '' : this.partecipa.totsaldo);

                                    //alert("importoacconto " + this.partecipa.importoacconto + " - importosaldo " + this.partecipa.importosaldo);
                                    //alert("importoscontoacconto " + this.partecipa.importoscontoacconto + " - importoscontosaldo " + this.partecipa.importoscontosaldo);

                                    this.showdettaglio = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

            //chiamo il servizio che mi restituisce i dati dell'evento
            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/eventi/' + this.partecipa.id_scheda, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {

                                //alert("Evento: " + JSON.stringify(res[0]))

                                this.partecipa.tipoevento = res[0].tipo;
                                if(this.partecipa.id == null && res[0].tipopagamento == 'A'){//se inserimento ricopio gli importo dall'evento al partecipa
                                    this.partecipa.importoacconto = res[0].importoacconto;
                                    this.partecipa.importosaldo = res[0].importosaldo;
                                    this.partecipa.tipopagamentoevento = res[0].tipopagamento;
                                }
                                //alert("Tipo evento " + this.tipoevento)

                                this.showdettaglio2 = true;

                            } else {
                                throw new Error("Errore evento non trovato!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

            //PAREMETRI
            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/cral', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            //alert("Ret: " + JSON.stringify(res))
                            if (typeof res == "object") {

                                this.parametri = res;
                                this.showdettaglio3 = true;

                            } else {
                                throw new Error("Errore parametri non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });



    },
        mounted: function() {



        }

}
</script>
